import { useCallback } from "react";
import { useRouter } from "next/router";

/**
 * Click handler for nav links that reloads the page when the user clicks
 * the menu item that already represents the current route. Without this,
 * Next.js throws a runtime "attempted to navigate to the same URL" warning
 * (and the click silently does nothing).
 *
 * Modifier keys (ctrl/cmd/shift/alt) and non-primary mouse buttons are
 * left alone so middle-click / cmd-click still opens in a new tab.
 */
export default function useNavReloadOnActive() {
  const router = useRouter();
  return useCallback(
    (e, href) => {
      if (!e || e.defaultPrevented) return;
      if (e.button !== 0) return; // primary button only
      if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;
      e.preventDefault();
      // Soft refresh: re-runs getStaticProps / getServerSideProps via
      // Next's data layer without re-downloading the JS bundle.
      router.reload();
      // href is unused but accepted so call sites read naturally:
      //   onClick={(e) => onActiveClick(e, item.href)}
    },
    [router]
  );
}
